import { render, staticRenderFns } from "./StaticModal.vue?vue&type=template&id=6103ff50&"
import script from "./StaticModal.vue?vue&type=script&lang=js&"
export * from "./StaticModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports